<script>
	import TBox from './templates/TBox.svelte';
</script>

<TBox 
	titulo="Suporte" 
	subtitulo="Para solicitar suporte, leia abaixo" 
	largura="8" 
	deslocamento="2" 
	correcaoY="-13px"
	icone="suporte">

	<div class="permitir-selecao">
		<p><strong>Para demandas sobre a SEMANA DE GRADUAÇÃO</strong> favor enviar e-mail para <strong class="has-text-primary">cetreina@gmail.com</strong>.</p>

		<hr>
		<p><strong>Para demais dúvidas e/ou esclarecimentos</strong> favor enviar e-mail para <strong>cetreina@gmail.com</strong>.</p>

		<br>

		<strong class="has-text-danger">AVISO IMPORTANTE!</strong>
		<p>O AVAL irá verificar automaticamente o cadastro de usuários, na maioria dos casos o desbloqueio para uso do sistema é automático. Caso seu acesso não seja liberado automaticamente, favor enviar e-mail para <strong class="has-text-primary"><a href="mailto:cetreina@gmail.com?subject=AVAL#SUPORTE (DESBLOQUEIO DE ACESSO)">cetreina@gmail.com</a></strong> informando no assunto (DESBLOQUEIO DE ACESSO) e no corpo do email informar nome, matrícula e CPF.</p>
	</div>

	<div class="has-text-centered mt-5">
		<a href="#/" class="button is-dark is-medium is-outlined">Início</a>
		<a href="#/acesso/recuperacao" class="button is-danger is-medium is-outlined">Recuperar Acesso</a>
		<a href="#/prazos" class="button is-primary is-medium is-outlined">Verificar PRAZOS</a>
	</div>
</TBox>